import React from 'react'
import { Box, Flex, Grid } from '@adsk/alloy-react-box'
import {
	ImageContentLoader,
	InputContentLoader,
	LabelContentLoader,
} from '@adsk/napi-shared'
import { AVATAR_SIZES } from '@adsk/alloy-react-avatar/es/constants'
type AvatarSizes = typeof AVATAR_SIZES
export type AvatarSize = AvatarSizes[keyof AvatarSizes]

const EditProfileLoaderComponent: React.FC = (): JSX.Element => {
	return (
		<React.Fragment>
			<Grid gridGap={2} marginTop={'2%'}>
				<LabelContentLoader />
				<LabelContentLoader />
			</Grid>
			<Grid
				gridGap={[2, 2]}
				padding={[15, 15]}
				gridAutoColumns={'auto'}
				gridTemplateColumns={['auto', '25% auto']}
			>
				<Grid gridGap={2} justifyContent={'center'}>
					<div style={{ position: 'relative', height: '100%' }}>
						<ImageContentLoader size={AVATAR_SIZES.XXLARGE_128} />
					</div>
				</Grid>
				<Grid gridGap={2}>
					<Flex flexDirection={'row'}>
						<Flex flex={'50%'} marginRight={1}>
							<InputContentLoader />
						</Flex>
						<Flex flex={'50%'} marginLeft={1}>
							<InputContentLoader />
						</Flex>
					</Flex>
					<Flex
						flexDirection={['column', 'row']}
						justifyContent={'space-between'}
					>
						<InputContentLoader />
					</Flex>
					<Box justifyContent={'center'}>
						<InputContentLoader />
					</Box>
				</Grid>
			</Grid>
			<Grid gridGap={2} marginBottom={'10%'}>
				<LabelContentLoader size="xs" />
				<InputContentLoader />
				<LabelContentLoader size="xs" />
				<InputContentLoader />
			</Grid>
		</React.Fragment>
	)
}

export default EditProfileLoaderComponent
